import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputAdornment,
  TablePagination,
  IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { getTipoAmenazas, deleteTipoAmenaza, createTipoAmenaza, updateTipoAmenaza } from '../../services/amenazas/tipoamenaza/tipoAmenazasData';
import { toast } from "react-toastify";

const TablaTAm = () => {
  const [datos, setDatos] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [modificarIndex, setModificarIndex] = useState(-1);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const tipoAmenazaData = await getTipoAmenazas();
        setDatos(Array.isArray(tipoAmenazaData) ? tipoAmenazaData : []);
      } catch (error) {
        console.error('Error fetching data:', error);
        setDatos([]);
      }
    };
    fetchData();
  }, []);

  const [formulario, setFormulario] = useState({
    Descripcion: '',
  });

  const handleBusquedaChange = (event) => {
    setBusqueda(event.target.value);
    setPage(0);
  };

  const handleInsert = () => {
    setModificarIndex(-1);
    setFormulario({
      Descripcion: '',
    });
    setModalOpen(true);
  };

  const handleFormChange = (event) => {
    setFormulario({
      ...formulario,
      [event.target.name]: event.target.value,
    });
  };

  const handleGuardar = async () => {
    if (!formulario.Descripcion || formulario.Descripcion.trim() === "") {
      toast.warning("La descripción es obligatoria");
      return;
    }
    try {
      const dataToSend = {
        tia_descripcion: formulario.Descripcion.trim()
      };

      if (modificarIndex !== -1) {
        await updateTipoAmenaza(modificarIndex, dataToSend);
        const tipoAmenazaData = await getTipoAmenazas();
        setDatos(Array.isArray(tipoAmenazaData) ? tipoAmenazaData : []);
        toast.success("Tipo de amenaza modificado correctamente");
      } else {
        await createTipoAmenaza(dataToSend);
        const tipoAmenazaData = await getTipoAmenazas();
        setDatos(Array.isArray(tipoAmenazaData) ? tipoAmenazaData : []);
        toast.success("Tipo de amenaza creado correctamente");
      }

      setModalOpen(false);
      setFormulario({
        Descripcion: '',
      });
    } catch (error) {
      const errorMessage = error?.message || error?.response?.data?.message || "Error al guardar el tipo de amenaza";
      toast.error(errorMessage);
      console.error("Error al guardar el tipo de amenaza:", error);
    }
  };

  const handleCancelar = () => {
    setModalOpen(false);
    setFormulario({
      Descripcion: '',
    });
  };

  const handleModificar = (index) => {
    setModificarIndex(datos[index].tia_codigo);
    setFormulario({
      Descripcion: datos[index].tia_descripcion,
    });
    setModalOpen(true);
  };

  const handleEliminar = (index) => {
    setDeleteIndex(index);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const codigoToDelete = datos[deleteIndex].tia_codigo;
      await deleteTipoAmenaza(codigoToDelete);
      toast.success("Tipo de amenaza eliminado correctamente");
      const tiposAmenazaData = await getTipoAmenazas();
      setDatos(Array.isArray(tiposAmenazaData) ? tiposAmenazaData : []);
      setConfirmOpen(false);
      setDeleteIndex(null);
    } catch (error) {
      setConfirmOpen(false);
      const errorMsg = error?.message || error?.response?.data?.message || '';
      if (errorMsg.includes('está siendo usado') || errorMsg.includes('siendo usado')) {
        setErrorMessage(errorMsg);
        setErrorModalOpen(true);
      } else {
        toast.error(errorMsg || "Error al eliminar el tipo de amenaza");
      }
      setDeleteIndex(null);
    }
  };

  const handleCancelDelete = () => {
    setConfirmOpen(false);
    setDeleteIndex(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const datosFiltrados = Array.isArray(datos) ? datos.filter((dato) =>
    dato.tia_descripcion && dato.tia_descripcion.toLowerCase().includes(busqueda.toLowerCase())
  ) : [];

  return (
    <Box>
      {/* Toolbar */}
      <Box
        sx={{
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          flexWrap: 'wrap',
          gap: 2
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder="Buscar tipo de amenaza..."
          value={busqueda}
          onChange={handleBusquedaChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleInsert}
          sx={{
            backgroundColor: '#001F3F',
            color: '#fff',
            '&:hover': { backgroundColor: '#003366' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Nuevo Tipo
        </Button>
      </Box>

      <TableContainer>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }}>Descripción</TableCell>
              <TableCell sx={{ fontWeight: 600, color: '#001F3F' }} align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {datosFiltrados.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                  <Typography variant="body1" sx={{ color: '#666' }}>
                    {datos.length === 0 ? "No hay tipos de amenazas registrados" : "No se encontraron resultados"}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              datosFiltrados
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((dato, index) => (
                  <TableRow key={dato.tia_codigo} hover>
                    <TableCell>
                      <Typography variant="body2" sx={{ color: '#001F3F' }}>
                        {dato.tia_descripcion}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <IconButton
                          onClick={() => handleModificar(index + (page * rowsPerPage))}
                          size="small"
                          sx={{ color: "#666" }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleEliminar(index + (page * rowsPerPage))}
                          size="small"
                          sx={{ color: "#d32f2f" }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={datosFiltrados.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
      />

      {/* Modal Formulario */}
      <Dialog
        open={modalOpen}
        onClose={handleCancelar}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ pb: 2, fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          {modificarIndex !== -1 ? 'Modificar Tipo de Amenaza' : 'Nuevo Tipo de Amenaza'}
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ mt: 2 }}>
            <TextField
              label="Descripción"
              name="Descripcion"
              fullWidth
              value={formulario.Descripcion}
              onChange={handleFormChange}
              variant="outlined"
              error={!formulario.Descripcion && modalOpen}
              helperText={!formulario.Descripcion && modalOpen ? "Campo obligatorio" : ""}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelar} sx={{ color: '#666' }}>Cancelar</Button>
          <Button
            onClick={handleGuardar}
            variant="contained"
            sx={{
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' }
            }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal Confirmación Eliminación */}
      <Dialog
        open={confirmOpen}
        onClose={handleCancelDelete}
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          Confirmar Eliminación
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#666' }}>
            ¿Está seguro que desea eliminar este tipo de amenaza?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelDelete} sx={{ color: '#666' }}>Cancelar</Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            sx={{
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' }
            }}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Error Informativo */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#001F3F', fontSize: '1.25rem' }}>
          No se puede eliminar
        </DialogTitle>
        <DialogContent>
          <Box sx={{ py: 2 }}>
            <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
              {errorMessage || 'Este tipo de amenaza no puede ser eliminado porque está siendo utilizado en el sistema.'}
            </Typography>
            <Typography variant="body2" sx={{ color: '#999', fontSize: '0.9rem' }}>
              Para poder eliminar este tipo de amenaza, primero debe eliminar o modificar todas las relaciones asociadas.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="contained"
            onClick={() => setErrorModalOpen(false)}
            sx={{ backgroundColor: '#001F3F', color: '#fff', '&:hover': { backgroundColor: '#003366' } }}
          >
            Entendido
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TablaTAm;
